<script>
//Repositories
import Repositories from '@/repositories';
const CategoryTypesRepository = Repositories.get('categorytypes');

//Components
import GridComponent from '@/components/widgets/grids/api-linked-grid';

export default {
  props: {
    fields: Array,
  },
  components: {
    GridComponent,
  },
  data() {
    return {
      categoryTypes: [],
      isLoading: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;

      CategoryTypesRepository.getAll()
        .then(({ data }) => {
          this.categoryTypes = data;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => (this.isLoading = false));
    },
    edit(idPublic) {
      this.$router.push({ name: 'editCategoryType', params: { idPublic } });
    },
  },
};
</script>

<template>
  <GridComponent
    id="category-types-grid"
    :fields="fields"
    :items="categoryTypes"
    :is-busy="isLoading"
  >
    <template #cell(name)="data">
      {{ $t(`categories.types.${data.item.name.toLowerCase()}`) }}
    </template>
    <template #cell(referenceDate)="data">
      <span v-if="data.item.referenceDate">
        {{ $t(`general.${data.item.referenceDate}`) }}
      </span>
    </template>
    <template #cell(edit)="data">
      <i
        class="fas fa-pencil-alt text-success pl-2 pr-2"
        @click="edit(data.item.idPublic)"
        style="cursor: pointer; font-size: 1.3em"
      />
    </template>
  </GridComponent>
</template>